/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Auth_Error_TitleInputs */

const en_meta_auth_error_title = /** @type {(inputs: Meta_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in problem | Listening.com`)
};

const es_meta_auth_error_title = /** @type {(inputs: Meta_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema al iniciar sesión | Listening.com`)
};

/**
* | output |
* | --- |
* | "Sign-in problem \| Listening.com" |
*
* @param {Meta_Auth_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_auth_error_title = /** @type {((inputs?: Meta_Auth_Error_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Auth_Error_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_auth_error_title(inputs)
	return en_meta_auth_error_title(inputs)
});